import Lodash from 'lodash';
import Popper from 'popper.js';
import 'bootstrap';
import jQuery from 'jquery';
import Axios from 'axios';
import TimeZoneDetect from 'jstimezonedetect';

//import AColorPicker from 'a-color-picker';
// import AColorPicker from 'a-color-picker';
const AColorPicker = require('a-color-picker');

window._ = Lodash;
window.Popper = Popper.default;
window.colorpicker = AColorPicker;
window.jstz = TimeZoneDetect;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.JQuery = jQuery;
} catch (e) { }

window.axios = Axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
let apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + apiToken.content;
} else {
    console.error('apiToken not found in metadata');
}
